/**
 * Пакеты пополнения и черновые цены.
 *
 * ⚠️ НЕ УТВЕРЖДЕНО владельцем (см. CLAUDE.md, docs/economics.md). Это единственное место,
 * где живут эти цифры: меняются здесь — меняется везде.
 */

/** 1 кредит = 1 ₽. */
export const CURRENCY = 'RUB' as const;

export interface TopUpPackage {
  id: string;
  /** Сколько платит юзер, ₽. */
  amount: number;
  /** Бонус сверху, % от суммы. */
  bonusPercent: number;
}

export const TOPUP_PACKAGES: readonly TopUpPackage[] = [
  { id: 'p149', amount: 149, bonusPercent: 0 },
  { id: 'p499', amount: 499, bonusPercent: 10 },
  { id: 'p990', amount: 990, bonusPercent: 15 },
  { id: 'p2490', amount: 2490, bonusPercent: 25 },
] as const;

/** Пакет, выбранный по умолчанию на экране пополнения (как в макете). */
export const DEFAULT_PACKAGE_ID = 'p499';

/** Черновая цена фото в ручном режиме «быстро», ₽ — для подсказки «N фото» на пакетах. */
export const DRAFT_PHOTO_PRICE_FAST = 9;

export function findPackage(id: string): TopUpPackage | undefined {
  return TOPUP_PACKAGES.find((p) => p.id === id);
}

/** Бонус в кредитах. Округление до целого по обычным правилам: 990 × 15% = 148,5 → 149. */
export function packageBonus(pkg: TopUpPackage): number {
  return Math.round((pkg.amount * pkg.bonusPercent) / 100);
}

/** Сколько кредитов придёт всего. */
export function packageCredits(pkg: TopUpPackage): number {
  return pkg.amount + packageBonus(pkg);
}

export function photosFor(credits: number): number {
  return Math.floor(credits / DRAFT_PHOTO_PRICE_FAST);
}

/**
 * Пакеты для плашки «Не хватает баланса»: самый маленький, которого хватает,
 * и следующий за ним (как в макете LowBalance).
 */
export function suggestPackages(balance: number, price: number): TopUpPackage[] {
  const shortage = Math.max(0, price - balance);
  const idx = TOPUP_PACKAGES.findIndex((p) => packageCredits(p) >= shortage);
  if (idx === -1) return [TOPUP_PACKAGES[TOPUP_PACKAGES.length - 1]!];
  return TOPUP_PACKAGES.slice(idx, idx + 2);
}
